module.exports = __webpack_public_path__ + "img/编组 6@2x.41deb6e1.png";